<template>
    <span>
        <a v-if="href" :href="href" class="icon_link" :target="target">
            <i class="mdi" :class="iconName"></i>
            <slot></slot>
        </a>

        <a v-if="!href" class="icon_link" :target="target">
            <i class="mdi" :class="iconName"></i>
            <slot></slot>
        </a>
    </span>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
    props: {
        iconName: {
            type: String,
            default: 'mdi-download',
        },
        href: {
            type: String,
        },
        target: {
            type: String,
            default: '_self',
        },
    },
})
export default class IconLink extends Vue {
    name = 'icon-link';
}

Vue.component('icon-link', IconLink);
</script>
